import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

const MoreInfo: FC = () => {
  return (
    <div className="hotline-more-info">
      <Typography variant="h2" className="w-full text-3xl px-24 text-center pt-6 pb-8 font-bold border-tc-7  border-t">
        More Information
      </Typography>

      <div className="grid grid-row-3 md:grid-cols-1 lg:grid-cols-3  flex w-full md:w-10/12 md:m-auto border-t py-5">
        <div>
          <Paper className="px-4 xl:px-8 h-48 md:h-72 xl:h-56 2xl:h-48 relative" elevation={0}>
            <Link href="https://rainn.org/what-weve-done-make-it-safe" className="pt-5 pb-8 text-xl font-bold text-pc-1">
              What We've Done to Make It Safe
            </Link>
            <Typography>Your safety is important to us. Learn about the steps RAINN has taken to protect your safety and anonymity.</Typography>
            <Link href="https://rainn.org/what-weve-done-make-it-safe" className="read-more">
              Read More
            </Link>
          </Paper>
        </div>
        <div>
          <Paper className="px-4 xl:px-8 h-48 md:h-72 xl:h-56 2xl:h-48 relative" elevation={0}>
            <Link href="https://rainn.org/what-you-can-do-make-it-safer" className="pt-5 pb-8 text-xl font-bold text-pc-1">
              What You Can Do to Make It Safer
            </Link>
            <Typography>Want to help a loved one but aren’t sure how? Here are some ways to get started.</Typography>
            <Link href="https://rainn.org/what-you-can-do-make-it-safer" className="read-more">
              Read More
            </Link>
          </Paper>
        </div>
        <div>
          <Paper className="px-4 xl:px-8 h-64 md:h-72 xl:h-56 2xl:h-48 relative" elevation={0}>
            <Link href="https://rainn.org/effects-sexual-violence-landing" className="pt-5 pb-8 text-xl font-bold text-pc-1">
              Effects of Sexual Violence
            </Link>
            <Typography>
              Visitors to the Online Hotline sometimes experience psychological, emotional, and physical effects of sexual violence. Learning more can help you find the best form of care to begin the
              healing process.
            </Typography>
            <Link href="https://rainn.org/effects-sexual-violence-landing" className="read-more">
              Read More
            </Link>
          </Paper>
        </div>
      </div>
      <div className="grid grid-row-2 sm:grid-cols-2 flex w-full md:w-10/12 md:m-auto">
        <div>
          <Paper className="px-4 xl:px-8 h-48 xl:h-40 relative" elevation={0}>
            <Link href="https://rainn.org/what-weve-done-make-it-safe" className="pt-5 pb-8 text-xl font-bold text-pc-1">
              Find a Local Service Provider
            </Link>
            <Typography>Local service providers make it easy for you to access care, and they are knowledgeable about the laws in your area and resources to assist you.</Typography>
            <Link href="https://rainn.org/what-weve-done-make-it-safe" className="read-more">
              Read More
            </Link>
          </Paper>
        </div>
      </div>
    </div>
  );
};

export default MoreInfo;
